export default {
      id: "social-twitter-usage",
      viewBox: "0 0 512 512",
      url: "/dist/svg/" + "sprite.svg#social-twitter-usage",
      toString: function () {
        return this.url;
      }
    }